/* el-faq.js — sections/el-faq.liquid
   One answer open at a time; clicking the open question closes it. */
(function () {
  'use strict';

  if (window.elFaqReady) return;
  window.elFaqReady = true;

  function setOpen(item, open) {
    var toggle = item.querySelector('[data-el-faq-toggle]');
    var answer = item.querySelector('.el-faq__answer');
    item.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (answer) answer.hidden = !open;
  }

  /* Smooth version: the row slides open / shut (el-accordion-motion.js) */
  function slide(item, open) {
    if (!window.elToggleHeight) { setOpen(item, open); return; }
    window.elToggleHeight(item, item.querySelector('.el-faq__answer'), function (o) { setOpen(item, o); }, open);
  }

  function openOnly(section, item, open, animate) {
    var set = animate ? slide : setOpen;
    section.querySelectorAll('[data-el-faq-item].is-open').forEach(function (other) { if (other !== item) set(other, false); });
    set(item, open);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-el-faq-toggle]');
    if (!toggle) return;
    var item = toggle.closest('[data-el-faq-item]');
    var section = toggle.closest('[data-el-faq]');
    if (!item || !section) return;
    openOnly(section, item, !item.classList.contains('is-open'), true);
  });

  /* Theme editor: open the question being edited */
  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest && event.target.closest('[data-el-faq-item]');
    var section = item && item.closest('[data-el-faq]');
    if (section) openOnly(section, item, true);
  });
})();
